import React from 'react';
import { URLS } from '../../consts/endpoints';

export default function MsLogin() {
  window.location.assign(URLS.MS_LOGIN);

  return <div></div>;
}
